// Brands allowed to be created
export const ALLOWEDBRANDS = ['BGT', 'CON', 'GDY', 'HKK', 'PRL']
